import React from 'react';
import { Switch } from 'antd';

function PublishToggle({ isPublished, setPublishStatus }) {
  return (
    <div style={{
      float: 'right',
    }}>
      <span style={{ marginRight: '10px' }}>{isPublished ? 'Published' : 'Draft'}</span>
      <Switch checked={isPublished} onChange={setPublishStatus} />
    </div>
  )
}

export default PublishToggle;


// WEBPACK FOOTER //
// ./src/pages/Admin/BlogDocument/BlogPublish/component.js